import { i18n } from "@/main";
import { Vue, Component } from "vue-property-decorator";
import { RestService } from "../../../services/rest-service";

@Component
export default class FindYourWayComponent extends Vue {
    private restService: RestService;
    private content: string;

    constructor() {
        super();
        this.restService = Vue.prototype.$restService;
        this.content = "";
    }

    private mounted() {
        var page = "findYouWay";
        this.restService.getStaticPage(page, i18n.locale, i18n.fallbackLocale.toString()).then((response) => {
            this.content = response.data;
        }).catch((error) => {
            // Get the static ressource with the fallback locale
            console.warn("Could not find " + page + " for current locale: " + i18n.locale);
            console.warn("Could not find " + page + " for fallback locale: " + i18n.fallbackLocale);
        });

    }
}
